import Overview from './Overview';
import Comparison from './Comparison';
import NationalInfographic from './NationalInfographic';
import IndividualESC from './IndividualESC';

export default [Overview, Comparison, NationalInfographic, IndividualESC];
